module.exports = __webpack_public_path__ + "static/media/placeholder.da1acc00.jpg";